// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IServicePlanDto } from './IServicePlanDto';
import {
    IServicePlanDtoFromJSON,
    IServicePlanDtoFromJSONTyped,
    IServicePlanDtoToJSON,
    IServicePlanDtoToJSONTyped,
} from './IServicePlanDto';

/**
 * 
 * @export
 * @interface ICategoryAllowedServiceDto
 */
export interface ICategoryAllowedServiceDto {
    /**
     * 
     * @type {number}
     * @memberof ICategoryAllowedServiceDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICategoryAllowedServiceDto
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof ICategoryAllowedServiceDto
     */
    sequence_id?: number;
    /**
     * 
     * @type {Array<IServicePlanDto>}
     * @memberof ICategoryAllowedServiceDto
     */
    plans?: Array<IServicePlanDto>;
}

/**
 * Check if a given object implements the ICategoryAllowedServiceDto interface.
 */
export function instanceOfICategoryAllowedServiceDto(value: object): value is ICategoryAllowedServiceDto {
    return true;
}

export function ICategoryAllowedServiceDtoFromJSON(json: any): ICategoryAllowedServiceDto {
    return ICategoryAllowedServiceDtoFromJSONTyped(json, false);
}

export function ICategoryAllowedServiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICategoryAllowedServiceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'sequence_id': json['sequence_id'] == null ? undefined : json['sequence_id'],
        'plans': json['plans'] == null ? undefined : ((json['plans'] as Array<any>).map(IServicePlanDtoFromJSON)),
    };
}

export function ICategoryAllowedServiceDtoToJSON(json: any): ICategoryAllowedServiceDto {
    return ICategoryAllowedServiceDtoToJSONTyped(json, false);
}

export function ICategoryAllowedServiceDtoToJSONTyped(value?: ICategoryAllowedServiceDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'sequence_id': value['sequence_id'],
        'plans': value['plans'] == null ? undefined : ((value['plans'] as Array<any>).map(IServicePlanDtoToJSON)),
    };
}

